import MenuLink from '../link/MenuLink';
import { Menu as MenuType } from './types';

interface Props {
  menu: MenuType;
  styles?: string;
}

export const FindMenu = ({ menu, styles }: Props) => {
  return (
    <div className={`dropdown dropdown-hover flex h-full items-center`}>
      <div className={`inline-flex h-full items-center gap-2 rounded-lg px-4 md:px-0 ${styles} `}>
        <MenuLink
          {...menu}
          prefetch={false}
          label=""
          type={'top'}
          hoverMainMenuEffect={false}
          hoverTopMenuEffect={false}
          styles="bg-gradient-blue-red-diagonal-light lg:hover:gradient-circle lg:hover:bg-find-icon-hover bg-find-icon-mobile lg:bg-find-icon w-[45px] h-[45px] lg:h-[50px] lg:w-[50px] rounded-full flex items-center transition-colors duration-200 group-hover:text-white h-full text-xs"
        />
      </div>
    </div>
  );
};
